import { DocumentCornSchema } from '@eigtech/documents-types';
import { z } from 'zod';
import { BaseTemplateSchema } from './base.js';
import { TimelineTemplateSchema, TimelineTemplateTypeSchema } from './timelineTemplates.js';
// Communication Template
export const CommunicationTemplateTypeSchema = z.literal('templates:types:communication');
export const CommunicationTemplateSchema = BaseTemplateSchema.merge(z.object({
    type: CommunicationTemplateTypeSchema,
    smsTemplate: z.string().optional().nullable(),
    subject: z.string().optional(),
    htmlTemplate: z.string(),
    textTemplate: z.string().optional(),
}));
// Note template
export const NoteTemplateTypeSchema = z.literal('templates:types:note');
export const NoteTemplateSchema = BaseTemplateSchema.merge(z.object({
    type: NoteTemplateTypeSchema,
    textTemplate: z.string(),
    textTemplateParams: z.string().array().optional(),
}));
export const DocumentTemplateTypeSchema = z.literal('templates:types:document');
export const DocumentTemplateSchema = BaseTemplateSchema.merge(z.object({
    documentId: DocumentCornSchema,
    type: DocumentTemplateTypeSchema,
}));
// Template
export const TemplateSchema = z.union([
    CommunicationTemplateSchema,
    DocumentTemplateSchema,
    NoteTemplateSchema,
    TimelineTemplateSchema,
]);
export const TemplateRecordSchema = z
    .object({
    PK: z.string(),
    SK: z.string(),
    'GSI-PK-1': z.string(),
    'GSI-SK-1': z.string(),
    deleted: z.boolean().optional(),
})
    .and(TemplateSchema);
export const TemplateTypesSchema = CommunicationTemplateTypeSchema.or(NoteTemplateTypeSchema)
    .or(TimelineTemplateTypeSchema)
    .or(DocumentTemplateTypeSchema);
